export const excludeUser = {
  organization_demo: {
    'optimized index builder': 'hidden',
    'optimized index': 'hidden',
    'structured index': 'hidden',
    'structured index builder': 'hidden',
    'factsheet builder': 'hidden',
  },
  demo_company: {
    'optimized index builder': 'hidden',
    'optimized index': 'hidden',
  },
  UBS: {
    'basket to index conversion': 'hidden',
  },
  'UBS APAC': {
    'basket to index conversion': 'hidden',
  },
  'UBS EMEA': {
    'basket to index conversion': 'hidden',
  },
  BNP: {
    'factsheet builder': 'hidden',
    'basket to index conversion': 'hidden',
  },
  Ultumus: {
    'basket to index conversion': 'hidden',
  },
  'Ultumus UAT': {
    'basket to index conversion': 'hidden',
  },
  MV_PD: {
    'optimized index builder': 'hidden',
    'optimized index': 'hidden',
    'structured index': 'hidden',
    'structured index builder': 'hidden',
    'factsheet builder': 'hidden',
    'rebalancing & reconstitution': 'hidden',
  },
  MV_OPS: {
    'optimized index builder': 'hidden',
    'optimized index': 'hidden',
    'structured index': 'hidden',
    'structured index builder': 'hidden',
    'factsheet builder': 'hidden',
    'rebalancing & reconstitution': 'hidden',
    'basket to index conversion': 'hidden',
    'bulk basket submission': 'hidden',
  },
  'Morgan Stanley': {
    'basket to index conversion': 'hidden',
    'bulk basket submission': 'hidden',
    'structured index': 'hidden',
    'structured index builder': 'hidden',
  },
  MarketVectorSandbox: {
    'optimized index builder': 'hidden',
    'optimized index': 'hidden',
    'structured index': 'hidden',
    'structured index builder': 'hidden',
    'factsheet builder': 'hidden',
    'rebalancing & reconstitution': 'hidden',
    'basket to index conversion': 'hidden',
    'bulk basket submission': 'hidden',
  },
  BITASandbox: {
    'basket to index conversion': 'hidden',
    'bulk basket submission': 'hidden',
  },
  Barclays: {
    'basket to index conversion': 'hidden',
    'bulk basket submission': 'hidden',
  },
  RBC: {
    'basket to index conversion': 'hidden',
    'bulk basket submission': 'hidden',
  },
};
